import { useState } from "react";
import { useNavigate } from "react-router-dom";

//Vapor Components
import Grid from "@vapor/react-material/Grid";
import Stack from "@vapor/react-material/Stack";
import IconButton from "@vapor/react-material/IconButton";
import VaporTag from "@vapor/react-custom/VaporTag";
import { DataGridPro, GridToolbar, itIT } from "@mui/x-data-grid-pro";

//Icons
import { ArrowForward as DetailIcon } from "@mui/icons-material";

//OneFront SDK
import { useTranslation } from "@1f/react-sdk";

//Custom styles
import {
  chipGreen,
  chipYellow,
  chipOrange,
  chipRed,
} from "../../businessLogic/styles";

//Custom components
import { NoData } from "../../components/NoData";

//Helpers
import {
  setLocalStorageSelectedFascicolo,
  setLocalStorageSelectedEntity,
} from "../../businessLogic/helpers/storageHelpers";

export const AnagrafichePivaErrate = ({ wrongRows }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [columns] = useState([
    { field: "id", headerName: "Id", type: "number", visible: false },
    {
      field: "cf",
      headerName: "Codice Fiscale",
      flex: 0.15,
      editable: false,
      filterable: true,
      visible: true,
    },
    {
      field: "pIva",
      headerName: "P. Iva",
      flex: 0.1,
      editable: false,
      filterable: true,
      visible: true,
    },
    {
      field: "ppe",
      headerName: "Persona politicamente esposta",
      flex: 0.25,
      editable: false,
      filterable: true,
      visible: true,
    },
    {
      field: "rischioAreaGeo",
      headerName: "Livello di rischio",
      flex: 0.15,
      editable: false,
      renderCell: (params) => renderLivelloRischio(params.row),
      valueGetter: (params) => renderLivelloRischioS(params.row),
      visible: true,
    },
    {
      field: "data",
      headerName: "Data ident.",
      type: "date",
      flex: 0.1,
      editable: false,
      filterable: true,
      visible: true,
      valueFormatter: (params) => {
        if (params.value == null) {
          return "";
        }
        return new Date(params.value).toLocaleDateString();
      },
    },
    {
      field: "actions",
      headerName: "",
      flex: 0.05,
      filterable: false,
      renderCell: (params) => renderDetailsButton(params.row),
    },
  ]);

  const renderLivelloRischio = (item) => {
    if (item.rischioAreaGeo !== undefined) {
      let livelloS = t("valutazione.form.rischioInerenteLivello1");
      let livelloC = chipGreen;

      switch (item.rischioAreaGeo) {
        case 1: {
          livelloS = t("valutazione.form.rischioInerenteLivello1");
          livelloC = chipGreen;
          break;
        }
        case 2: {
          livelloS = t("valutazione.form.rischioInerenteLivello2");
          livelloC = chipYellow;
          break;
        }
        case 3: {
          livelloS = t("valutazione.form.rischioInerenteLivello3");
          livelloC = chipOrange;
          break;
        }
        case 4: {
          livelloS = t("valutazione.form.rischioInerenteLivello4");
          livelloC = chipRed;
          break;
        }
        default: {
          break;
        }
      }

      return <VaporTag variant="standard" label={livelloS} sx={livelloC} />;
    } else {
      return null;
    }
  };

  const renderLivelloRischioS = (item) => {
    if (item.rischioAreaGeo !== undefined) {
      let livelloS = t("valutazione.form.rischioInerenteLivello1");

      switch (item.rischioAreaGeo) {
        case 1: {
          livelloS = t("valutazione.form.rischioInerenteLivello1");
          break;
        }
        case 2: {
          livelloS = t("valutazione.form.rischioInerenteLivello2");
          break;
        }
        case 3: {
          livelloS = t("valutazione.form.rischioInerenteLivello3");
          break;
        }
        case 4: {
          livelloS = t("valutazione.form.rischioInerenteLivello4");
          break;
        }
        default: {
          break;
        }
      }

      return livelloS;
    } else {
      return null;
    }
  };

  const renderDetailsButton = (item) => {
    if (item.id !== undefined) {
      return (
        <Stack direction="row" spacing={0}>
          <IconButton
            color="primary"
            onClick={(e) => handleGridBtnDetailClick(e, item)}
          >
            <DetailIcon />
          </IconButton>
        </Stack>
      );
    } else {
      return null;
    }
  };

  const handleGridBtnDetailClick = (event, item) => {
    if (item.fascicoloId !== undefined && item.id !== undefined) {
      event.stopPropagation();
      setLocalStorageSelectedFascicolo(item.fascicoloId);
      setLocalStorageSelectedEntity("anagrafica", item.id, item.tipoAnagrafica);
      navigate("/fascicolo/manage");
    }
  };

  if (!wrongRows || wrongRows.length === 0) {
    return (
      <Grid container>
        <Grid item xs={12} sx={{ width: "100%" }}>
          <NoData size="small" />
        </Grid>
      </Grid>
    );
  }

  return (
    <Grid container>
      <Grid item xs={12} sx={{ width: "100%" }}>
        <DataGridPro
          rows={wrongRows}
          columns={columns}
          getRowId={(row) => row.pathId}
          autoHeight={true}
          slots={{ toolbar: GridToolbar }}
          pageSizeOptions={[25, 50, 100]}
          disableChildrenFiltering={true}
          localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
          groupingColDef={{
            headerName: "Denominazione",
            flex: 0.4,
            hide: false,
            filterable: true,
          }}
          getCellClassName={(params) => {
            if (params.field === "pIva" && params.row.isPivaWrong) {
              return "cell-error";
            }
            return "";
          }}
          pagination
          disableRowSelectionOnClick
          treeData
          getTreeDataPath={(row) => row.path}
          onRowClick={(item, e) => handleGridBtnDetailClick(e, item.row)}
          initialState={{
            columns: {
              columnVisibilityModel: {
                id: false,
              },
            },
            pagination: {
              paginationModel: {
                pageSize: 25,
              },
            },
          }}
          slotProps={{
            toolbar: { printOptions: { disableToolbarButton: true } },
          }}
        />
      </Grid>
    </Grid>
  );
};
